import {
  GridActionsCellItem,
  GridRowParams,
} from '@mui/x-data-grid';
import { Paper, IconButton, Grid, Tooltip, Alert } from '@mui/material';
import {
  Edit as EditIcon,
  Sync,
} from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import userService from '../../../services/authority/userService';
import accountService from '../../../services/accountService';
import DataList from '../../../components/DataList';

const asStringList = (value: unknown): string[] => {
  if (!Array.isArray(value)) return [];
  return value.map(String).filter(Boolean);
};

const SaaSUsersPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();

  const loadUsers = () => {
    dispatch({ type: 'SHOW_QUERY' });
    userService
      .listPlatform()
      .then((response) => {
        if (!response.hasError) {
          setRows(
            (response.records ?? []).map((x: any) => ({
              ...x,
              id: x.id ?? x.Id,
              fullName: x.fullName ?? x.FullName ?? '',
              email: x.email ?? x.Email ?? '',
              groupNames: asStringList(
                x.groupNames ?? x.GroupNames
              ).join(', ') || '—',
              platformRoleNames: asStringList(
                x.platformRoleNames ?? x.PlatformRoleNames
              ).join(', ') || '—',
            }))
          );
        } else {
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        }
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const columns: any[] = [
    { field: 'fullName', headerName: 'Megjelenítési név', flex: 120 },
    { field: 'email', headerName: 'Email', flex: 140 },
    {
      field: 'platformRoleNames',
      headerName: 'Platform szerepkör',
      flex: 160,
    },
    {
      field: 'actions',
      type: 'actions',
      flex: 40,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          key="edit"
          icon={
            <Tooltip title="Szerkesztés">
              <EditIcon />
            </Tooltip>
          }
          label="Edit"
          color="primary"
          onClick={() => navigate(`/authority/saas-users/edit/${params.row.id}`)}
        />,
      ],
    },
  ];

  return (
    <Paper>
      <Grid container sx={{ p: 3 }} spacing={2}>
        <Grid size={12}>
          <h2>SaaS felhasználók</h2>
        </Grid>
        <Grid size={12}>
          <Alert severity="info">
            Platform hatókör: platform szerepkör hozzárendelés. A bérlői tagság /
            szerepkörök a Felhasználók oldalon vannak.
          </Alert>
        </Grid>
        <Grid container size={12} sx={{ justifyContent: 'end' }}>
          <Tooltip title="AAD felhasználók szinkronizálása">
            <IconButton
              onClick={() => {
                accountService
                  .syncUsers()
                  .then(() => {
                    enqueueSnackbar('Sikeres szinkronizáció!', {
                      variant: 'success',
                    });
                    setTimeout(() => loadUsers(), 2000);
                  })
                  .catch(() => {
                    enqueueSnackbar('Sikertelen szinkronizáció!', {
                      variant: 'error',
                    });
                  });
              }}
              color="primary"
            >
              <Sync />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid size={12}>
          <DataList rows={rows} columns={columns} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SaaSUsersPage;
